module.exports = __webpack_public_path__ + "static/img/img-ppjs@2x.74709cb5.png";